export const VertexType = {
  Tube: 'tube',
  DLR: 'dlr',
  Overground: 'overground',
  Elizabeth: 'elizabeth',
  Tram: 'tram',
} as const
export type VertexType = (typeof VertexType)[keyof typeof VertexType]

export type LineID = string

export interface Vertex {
  readonly id: string
  readonly x: number
  readonly y: number
  readonly type: VertexType
  readonly lineID: LineID
  /** Shared TfL identifier for cluster siblings (e.g. station-tha-STE0
   *  and station-tha-STE1 carry the same `naptanId`). Used by the
   *  algorithm to detect cluster-revisits and dedup variants. */
  readonly naptanId?: string
}

export function sameID(a: Vertex, b: Vertex): boolean {
  return a.id === b.id
}

export const EdgeType = {
  Ride: 'ride',
  WalkTransfer: 'walk_transfer',
  WithinStationTransfer: 'within_station_transfer',
} as const
export type EdgeType = (typeof EdgeType)[keyof typeof EdgeType]

export interface Edge {
  readonly from: Vertex
  readonly to: Vertex
  readonly weight: number
  readonly type: EdgeType
  readonly realID: string
  /** `true` for a STREET walk edge (schema transition `street: true`,
   *  1.27.0+) — a pedestrian link between two different physical
   *  stations outside the gate line (Edgware Road ERB↔ERC). The
   *  converter emits such edges as street-walk legs (EMPTY
   *  transition_id) so presentation renders the exit → street →
   *  re-entry sequence instead of an in-station transfer pill. */
  readonly street?: boolean
}
